import Mock from "mockjs";
import menuAPI from "./menu";

// 修复在使用 MockJS 情况下，设置 withCredentials = true，且未被拦截的跨域请求丢失 Cookies 的问题
// https://github.com/nuysoft/Mock/issues/300
Mock.XHR.prototype.proxy_send = Mock.XHR.prototype.send;
Mock.XHR.prototype.send = function() {
  if (this.custom.xhr) {
    this.custom.xhr.withCredentials = this.withCredentials || false;
  }
  if (!this.match && this.responseType === "blob") {
    this.custom.xhr.responseType = "blob"; //附件乱码问题
  }
  this.proxy_send(...arguments);
};

Mock.setup({
  timeout: "350-600"
});

// demo工程数据模拟接口
// Mock.mock(/\/queryDemoList/, "post", demoListAPI.getData);
Mock.mock(/\/apis\/demo\/app\/getAuthMenu/, "post", menuAPI.getData);

export default Mock;
